import { Image } from '@components/gassan-ui'
import { CleanLink } from '@components/gassan-ui/Link/CleanLink'
import { Heading } from '@components/rolex-ui/Heading'
import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'
import { getKontentImage } from '@lib/kontent'
import { RolexCollectionPage } from '@lib/kontent/models/RolexCollectionPage'
import Link from 'next/link'
import { FC } from 'react'
import { RolexContainer } from './Container'

type RolexCollectionGridProps = {
  title: string
  items: RolexCollectionPage[]
  className?: string
}

export const RolexCollectionGrid: FC<RolexCollectionGridProps> = ({ title, items, className }) => {
  return (
    <RolexContainer className={cn('py-[30px] md:py-[45px] lg:py-[60]', className)}>
      <Heading variant="headline36" as="h3" className="mb-4 text-rolexBrown">
        {title}
      </Heading>
      <div className="grid grid-cols-2 gap-x-2 gap-y-8 md:grid-cols-3 md:gap-y-10">
        {items.map((item, index) => (
          <Link href={`/rolex/${item.url_slug.value}`} key={index} passHref>
            <CleanLink>
              <div className="group flex flex-col gap-2">
                <Image
                  className={cn(
                    'aspect-[3/4] opacity-100 transition-opacity duration-150 group-hover:opacity-80 md:aspect-[3/2]',
                  )}
                  sources={[
                    getKontentImage(item.mobile_image.value[0]?.url, { width: 768 }),
                    ...[768, 1024].map((width) =>
                      getKontentImage(item.desktop_image.value[0]?.url, { width }),
                    ),
                  ]}
                  placeholderSrc={getKontentImage(item.desktop_image.value[0]?.url, {
                    width: 50,
                    height: 50,
                  })}
                  alt={item.desktop_image.value[0]?.description as string}
                />
                <div className="flex flex-col items-start">
                  <Text variant="legend16" className="text-rolexBrown">
                    Rolex
                  </Text>
                  <Text variant="body24" className="text-rolexBrown">
                    {item.collection_name.value}
                  </Text>
                </div>
              </div>
            </CleanLink>
          </Link>
        ))}
      </div>
    </RolexContainer>
  )
}
